<template>
  <div class="home">
    <van-nav-bar fixed placeholder title left-arrow left-text="返回" right-text="搜索" @click-left="onClickLeft"
                 @click-right="onSearch">
      <template #title>
        <van-search clearable shape="round" v-model="value" placeholder="请输入搜索关键词"/>
      </template>
      <template #right></template>
    </van-nav-bar>
    <div v-if="false" class="tabpath">访问路径： {{ requestPath }}</div>

    <van-tabs v-model="active" color="#6db4e1" @click="getCurrentList">
      <van-tab v-for="node in tabList" :key="node.id" :name="node.id" :title="node.name">
        <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh"> -->
        <van-list style="padding-bottom:100px" v-model="loading" :finished="finished" finished-text @load="onLoad">
          <van-cell title-style="text-align:left;" class="iconfont" v-for="info in currentList" :key="info.id"
                    :title="info.name" :is-link="!info.url" icon-prefix="icon"
                    :icon="(!info.url?'wenjianjia':(info.url.indexOf('.pdf')>0?'wenjian':'seiyw41'))"
                    @click="getCurrentList((info.id==0)?(info.url.match(/\d+/g)[0]):info.id)"/>
        </van-list>
        <!-- </van-pull-refresh> -->
      </van-tab>
    </van-tabs>

    <div class="m-l-5 m-r-5 f-16 p-b-20" style="position:fixed;bottom:0px;left:0px;right:0px;background: #FFF;"
         v-show="hasCase"
         @click="goCase">
      <van-button style="font-size:16px;" color="#45a4b6" type="primary" block>此车案例</van-button>
    </div>
  </div>
</template>

<script>
import {
  NavBar,
  Tab,
  Tabs,
  Search,
  Image as VanImage,
  Icon,
  List,
  PullRefresh,
  Cell,
  CellGroup,
  Tabbar,
  TabbarItem,
  Toast,
  Button
} from "vant";
// @ is an alias to /src
import {Get_Brand_Node_List, Get_File_Node_List, Has_Case} from "@/api/index";

export default {
  name: "FileMenu",
  components: {
    [NavBar.name]: NavBar,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Search.name]: Search,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
    [VanImage.name]: VanImage,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Toast.name]: Toast,
    [Button.name]: Button,
  },
  data() {
    return {
      active: "",
      brandId:0,
      searching: false,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      value: "",
      currentList: [],
      tabs: [],
      historyList: [],
      hasCase: false
    };
  },
  computed: {
    tabList() {
      if (this.searching) {
        return this.list.slice(this.list.length - 1)
      } else {
        return this.list.slice(0, this.list.length - 1)
      }
    },
    requestPath: function () {
      return this.tabs.join(" > ");
    },

  },
  methods: {
    goCase() {
      this.$router.push({
        path: "/repair/caselist",
        query: {brandId: this.brandId},
      });
    },
    async getCaseList() {
      Has_Case({brandId: this.brandId}).then((data) => {
        this.hasCase = +data > 0
      });
    },
    async onSearch() {
      if (this.value == "") {
        Toast("请输入关键词");
        return;
      }
      if (!this.searching) {
        //添加回退记录
        this.historyList.push(this.currentList);
      }
      this.searching = true
      this.current = 0;
      this.currentList = await this.getFileNodeList(this.brandId); //this.$route.params.id
    },
    async getBrandNodeList() {
      var params = {
        id: this.brandId,
        depth: 6,
      };
      debugger
      let list = await Get_Brand_Node_List(params);
      list.push({
        id: this.brandId,
        name: '搜索结果'
      });
      this.list = list;
      this.getCurrentList(this.list[0].id, 1);
    },
    async getFileNodeList(id) {
      var params = {
        id: id,
        key: this.value,
      };
      return await Get_File_Node_List(params);
    },
    onClickLeft() {
      if (this.searching) {
        this.searching = false;
        this.keyword = ''
      }
      if (this.historyList.length > 1) {
        this.currentList = this.historyList.pop();
      } else {
        this.$router.back();
      }
    },
    async getCurrentList(id, isMenu) {
      this.value = "";
      var node = (isMenu ? this.list : this.currentList).find(
          (item) => item.id == id || (!this.global.isNull(item.url) && item.url.indexOf(id) > 0)
      );
      if (node) {
        if (!node.url) {
          //添加回退记录
          this.historyList.push(this.currentList);
          if (!node.children) {
            node.children = [];
          }
          this.currentList = node.children;
          if (!node.isLoadFileList) {
            Toast.loading({
              message: "加载中...",
              forbidClick: true,
              duration: 0,
            });
            let fileList = await this.getFileNodeList(id);
            node.isLoadFileList = true;

            if (fileList.length > 0) {
              fileList.forEach((e) => {
                this.currentList.push(e);
              });
            }

            Toast.clear();
          }

          if (isMenu) {
            this.tabs.splice(0);
          }
          this.tabs.push(node.name);
        } else {
          //末节点处理
          // sessionStorage.setItem("currentList", this.currentList);
          // sessionStorage.setItem(
          //   "filePath",
          //   node.url.replace(/\/file\//, "/m/file/")
          // );
          // sessionStorage.setItem("fileName", node.name);

          node.brandId = this.brandId;
          sessionStorage.setItem("fileNode", JSON.stringify(node));
          this.$router.push({path: "/fileshow"});
        }
      }
    },
  },
  mounted() {
    this.loading = false;
    this.finished = true;
    this.brandId = this.$route.params.id
    this.getBrandNodeList();
    this.getCaseList()
  },
};
</script>
<style>
.van-search {
  padding: 5px 0;
}

.van-cell__left-icon {
  color: #DAA520;
}
</style>
